import { Component, Input, OnInit } from "@angular/core";
import { MacAddressService } from "../../../services/mac-address.service";

@Component({
    selector : 'dl-print-mac-address-result',
    templateUrl : './print-mac-address-result.component.html',
    styleUrls : [
        './print-mac-address-result.component.scss'
    ]
})

export class PrintMacAddressResultComponent implements OnInit {

    @Input() tableData? = [];
    constructor(private addressService : MacAddressService) {}

    ngOnInit(): void { }

    prepareErrorMessage(error) {
        return this.addressService.prepareErrorMessage(error);
    }

}
